export default __webpack_public_path__ + "static/media/empty-bag.459564a6.png";